import apiClient from "@/api/client";
import type { InternalUser } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export interface ListInternalUsersOptions {
  includeFridayContractors?: boolean;
  /** ALL active contractors (no Friday flag) — meetings invitee picker. */
  includeContractors?: boolean;
  /** Own branch only (plus users flagged is_cross_branch_visible). */
  sameBranch?: boolean;
  /** Contractors granted DLC_02 — correspondence register addressee pickers. */
  includeDlc02Contractors?: boolean;
}

export const internalUsersApi = {
  list: (options: ListInternalUsersOptions = {}) => {
    const params: Record<string, string> = {};
    if (options.includeFridayContractors) {
      params.include_friday_contractors = "true";
    }
    if (options.includeContractors) {
      params.include_contractors = "true";
    }
    if (options.sameBranch) {
      params.same_branch = "true";
    }
    if (options.includeDlc02Contractors) {
      params.include_dlc02_contractors = "true";
    }
    return apiClient
      .get<{ data: InternalUser[] }>("/users/", { params })
      .then(wrap);
  },
};
